var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "IcClosingCross",

    getDefaultProps () {
        return {"width":"18px","height":"18px","viewBox":"0 0 18 18","version":"1.1","xmlns":"http://www.w3.org/2000/svg","data-svgreactloader":"[[\"http://www.w3.org/2000/svg\",\"xlink\",\"http://www.w3.org/1999/xlink\"]]"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <title>ic_closing_cross</title>
  <desc>Created with Sketch.</desc>
  <defs/>
  <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
    <g id="ic_closing_cross" fillRule="nonzero" fill="#555555">
      <path d="M9.70710678,9 L17.2071068,1.5 L16.5,0.792893219 L9,8.29289322 L1.5,0.792893219 L0.792893219,1.5 L8.29289322,9 L0.660147268,16.632746 L1.36725405,17.3398527 L9,9.70710678 L16.632746,17.3398527 L17.3398527,16.632746 L9.70710678,9 Z" id="closing_cross"/>
    </g>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/images/ic_closing_cross.svg